// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"428":"e5ce8648","714":"e5ce8648","846":"063271ef","943":"e5ce8648"}[chunkId] + ".chunk.css";
};